import React from 'react'
import { Box, Fab, TextField, Typography } from '@mui/material'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import LastPageIcon from '@mui/icons-material/LastPage'
import { saveAs } from 'file-saver'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import PDFPrinter from './PDFPrinter'

const ControlPanel = ({ file, filename, pageNumber, numPages, setPageNumber, scale, setScale }) => {
  const isFirstPage = pageNumber === 1
  const isLastPage = pageNumber === numPages

  const save = () => {
    if (file && filename) {
      fetch(file)
        .then((res) => res.blob())
        .then((blob) => {
          saveAs(blob, filename)
        })
        .catch()
    }
  }

  const goToFirstPage = () => {
    if (!isFirstPage) setPageNumber(1)
  }
  const goToPreviousPage = () => {
    if (!isFirstPage) setPageNumber(pageNumber - 1)
  }
  const goToNextPage = () => {
    if (!isLastPage) setPageNumber(pageNumber + 1)
  }
  const goToLastPage = () => {
    if (!isLastPage) setPageNumber(numPages)
  }

  const onPageChange = (e) => {
    let value = Number(e.target.value)
    if (isNaN(value)) return
    if (value < 1) value = 1
    if (numPages && value > numPages) value = numPages
    setPageNumber(value)
  }

  const isMinZoom = scale < 0.6
  const isMaxZoom = scale >= 2.0

  const zoomOut = () => {
    if (!isMinZoom) setScale(scale - 0.1)
  }

  const zoomIn = () => {
    if (!isMaxZoom) setScale(scale + 0.1)
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Fab
          disabled={isFirstPage}
          sx={{ mx: 0.5 }}
          size='small'
          color='primary'
          aria-label='go to first page'
          onClick={goToFirstPage}
        >
          <FirstPageIcon />
        </Fab>
        <Fab
          disabled={isFirstPage}
          sx={{ mx: 0.5 }}
          size='small'
          color='primary'
          aria-label='go to previous page'
          onClick={goToPreviousPage}
        >
          <ChevronLeftIcon />
        </Fab>

        <Box sx={{ display: 'flex', alignItems: 'center', mx: 1 }}>
          <Typography sx={{ mx: 0.5 }}>Page</Typography>
          <TextField
            size='small'
            variant='outlined'
            type='number'
            inputProps={{ min: 1, max: numPages || 1 }}
            value={pageNumber}
            name='pageNumber'
            onChange={onPageChange}
          />
          <Typography sx={{ mx: 0.5 }}>sur {numPages}</Typography>
        </Box>

        <Fab
          disabled={isLastPage}
          sx={{ mx: 0.5 }}
          size='small'
          color='primary'
          aria-label='go to next page'
          onClick={goToNextPage}
        >
          <ChevronRightIcon />
        </Fab>
        <Fab
          disabled={isLastPage}
          sx={{ mx: 0.5 }}
          size='small'
          color='primary'
          aria-label='go to last page'
          onClick={goToLastPage}
        >
          <LastPageIcon />
        </Fab>
      </Box>

      <Box sx={{ mx: 0.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Fab disabled={isMinZoom} sx={{ mx: 0.5 }} size='small' color='primary' aria-label='zoom out' onClick={zoomOut}>
          <ZoomOutIcon />
        </Fab>
        <Typography sx={{ mx: 0.5, width: '40px', textAlign: 'center' }}>{(scale * 100).toFixed()}%</Typography>
        <Fab disabled={isMaxZoom} sx={{ mx: 0.5 }} size='small' color='primary' aria-label='zoom in' onClick={zoomIn}>
          <ZoomInIcon />
        </Fab>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
        <Fab
          sx={{ mx: 0.5 }}
          size='small'
          color='primary'
          aria-label='download file'
          onClick={save}
          disabled={!file || !filename}
        >
          <FileDownloadIcon />
        </Fab>
        <PDFPrinter file={file} />
      </Box>
    </Box>
  )
}

export default ControlPanel
